module.exports = __webpack_public_path__ + "img/help7_dashboard_annotation.522a4671.png";